import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Inspeccion30Y31Ano2024SistemasDeMedicion() {
  return <CategoryPage category="inspeccion30Y31Ano2024SistemasDeMedicion" pageTitle="Sistemas De Medición" />;
}

export default Inspeccion30Y31Ano2024SistemasDeMedicion;
